import { TFunction } from "i18next";

import { SortOptions } from "@/components/type";

interface ILayoutOption {
  sortOptions: { label: string; value: SortOptions }[];
  hideFilter: boolean;
  searchPlaceholder?: string;
}

// TODO(karlbernard2): [NX-13206] Keep the named layout-options API on its established module path.
// eslint-disable-next-line import/prefer-default-export -- Preserve the established named layout-options API.
export const getLayoutOptions = (translate: TFunction): Record<string, ILayoutOption> => ({
  chatbots: {
    sortOptions: [
      {
        label: translate("myCreation:sort.latest"),
        value: SortOptions.LATEST,
      },
      {
        label: translate("myCreation:sort.oldest"),
        value: SortOptions.OLDEST,
      },
      {
        label: translate("myCreation:sort.topRated"),
        value: SortOptions.TOP_RATED,
      },
      {
        label: translate("myCreation:sort.name"),
        value: SortOptions.NAME,
      },
    ],
    hideFilter: false,
  },
  groups: {
    sortOptions: [
      {
        label: translate("myCreation:sort.latest"),
        value: SortOptions.LATEST,
      },
      {
        label: translate("myCreation:sort.oldest"),
        value: SortOptions.OLDEST,
      },
      {
        label: translate("myCreation:sort.topRated"),
        value: SortOptions.TOP_RATED,
      },
    ],
    hideFilter: false,
  },
  lorebooks: {
    sortOptions: [
      {
        label: translate("myCreation:sort.latest"),
        value: SortOptions.LATEST,
      },
      {
        label: translate("myCreation:sort.oldest"),
        value: SortOptions.OLDEST,
      },
    ],
    hideFilter: false,
  },
  rulebooks: {
    sortOptions: [
      {
        label: translate("myCreation:sort.recentlyUpdated", "Recently updated"),
        value: SortOptions.LATEST,
      },
      {
        label: translate("myCreation:sort.oldest"),
        value: SortOptions.OLDEST,
      },
    ],
    hideFilter: true,
    searchPlaceholder: translate("rulebook:list.searchPlaceholder", "Search by name, description or meter"),
  },
  voices: {
    sortOptions: [
      {
        label: translate("myCreation:sort.latest"),
        value: SortOptions.LATEST,
      },
      {
        label: translate("myCreation:sort.oldest"),
        value: SortOptions.OLDEST,
      },
    ],
    hideFilter: true,
  },
});
